import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/home/index.vue'),
    meta: {
      title: '首页',
      keepAlive: true,
    },
  },
  {
    path: '/mp/payment',
    name: 'MembershipPayment',
    component: () => import('@/views/mp/membership/MpPayment.vue'),
    meta: {
      title: '良缘会员',
      keepAlive: false,
    },
  },
  {
    path: '/mp/customerService',
    name: 'customerService',
    component: () => import('@/views/mp/customerService/index.vue'),
    meta: {
      title: '良缘会员',
      keepAlive: false,
    },
  },
  {
    path: '/invite/promotion',
    name: 'Promotion',
    component: () => import('@/views/invite/promotion.vue'),
    meta: {
      title: '望子良缘',
      keepAlive: false,
    },
  },
  {
    path: '/invite/promotionAutoJump',
    name: 'promotionAutoJump',
    component: () => import('@/views/invite/promotionAutoJump.vue'),
    meta: {
      title: '望子良缘',
      keepAlive: false,
    },
  },
  {
    path: '/invite/landingPageGenerator',
    name: 'LandingPageGenerator',
    component: () => import('@/views/invite/landingPageGenerator.vue'),
    meta: {
      title: '落地页生成工具',
      keepAlive: false,
    },
  },
  {
    path: '/examples/swiper',
    name: 'SwiperExample',
    component: () => import('@/views/examples/SwiperExample.vue'),
    meta: {
      title: 'Swiper轮播图示例',
      keepAlive: false,
    },
  },
  {
    path: '/test/index',
    name: 'TestIndex',
    component: () => import('@/views/TEST/index.vue'),
    meta: {
      title: '测试',
      keepAlive: false,
    },
  },
  {
    path: '/sidebar/customer',
    name: 'SidebarCustomer',
    component: () => import('@/views/sidebar/CustomerInfo.vue'),
    meta: {
      title: '客户资料',
      keepAlive: false,
    },
  },
  {
    path: '/mp/newPayment',
    name: 'NewMembershipPayment',
    component: () => import('@/views/mp/membership/NewMpPayment.vue'),
    meta: {
      title: '良缘会员',
      keepAlive: false,
    },
  },
  {
    path: '/index1',
    name: 'HomeIndex1',
    component: () => import('@/views/home/index1.vue'),
    meta: {
      title: '望子良缘',
      keepAlive: false,
    },
  },
  {
    path: '/mp/xiyuanDetails',
    name: 'MpXiyuanDetails',
    component: () => import('@/views/mp/membership/xiyuanDetails.vue'),
    meta: {
      title: '囍缘会员',
      keepAlive: false,
    },
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/views/error/404.vue'),
    meta: {
      title: '404',
      keepAlive: false,
    },
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.VITE_APP_BASE_PATH),
  routes,
})

// 全局路由守卫
router.beforeEach(
  (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
    // 设置标题
    document.title = (to.meta.title as string) || '望子良缘'
    next()
  }
)

export default router
